export const PEST_SHARE_CONTACT = {
  phone: '2089184663',
  providerName: 'Pest Share',
  email: 'servicerequests@pestshare.com',
}

export const CONTACT_TYPES = {
  PHONE: 'phone',
  EMAIL: 'email',
  CHAT: 'chat',
} as const
